// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-581304a8] .app-sidebar-header__description{flex-direction:column}", ""]);
// Exports
module.exports = exports;
